var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState } from "react";
import { useStyles } from "./assets/style";
import "./assets/style.css"; // @ts-ignore
import { ButtonAFY, icons, sizes, sizesIcon, typeAlert, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { themeCore } from "../../assets/themes/theme";
import * as catalogConst from "../../const/catalog";
import { STEP_CONFIRMATIONFORM } from "../../const/catalog";
import { formatPhoneNumber } from "../../utils/formats";
import { navigateNext, stepProgress } from "../../dataBase/stepProgress";
import { Customer } from "../../enum/customer";
import { Steps } from "../../enum/steps";
import { PostUploadDocuments } from "../../fnx/apaAuditDocuments/quoteUploadDocuments";
import { GetCatalogBeneficiary } from "../../fnx/catalog/getCatalogBeneficiary";
import { GetCatalogInsurance } from "../../fnx/catalog/getCatalogInsurance";
import { GetPaymentMode } from "../../fnx/paymentMode/getPaymentMode";
import { useCertificateQuote } from "../../fnx/certificate/certificateQuotes";
import { getCustomerAction, isCustomer } from "../../fnx/customer";
import { GetPersonByDocument } from "../../fnx/person/getPersonByDocument";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { formatDocument, getLogin, removeNonNumeric, transformToSelect, } from "../../services/functions";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { postQuoteUploadDocumentClearData } from "../../store/apapUploadAttachments/actions";
import { benefitClearData, getBeneficiary, patchBeneficiaryClearData, } from "../../store/beneficiary/actions";
import { certificateQuoteClearData } from "../../store/certificates/actions";
import { countries } from "../../store/countries/actions";
import { quoteClearData, quoteOne } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { insured, patchInsuredClearData, postInsuredClearData, } from "../../store/insured/actions";
import { pageActionFlagsClearData } from "../../store/pageActionFlags/actions";
import { personByDocumentClearData } from "../../store/person/actions";
import { catalogGender } from "../../store/plan/actions";
import { plans } from "../../store/plans/actions";
import { projectOne, projectOneClearData } from "../../store/project/actions";
import { region } from "../../store/region/actions";
import { formattedDate, newFormattedDate } from "../../utils/date";
import { formatNumberCustom, formatToTwoDecimals, parsePrice, } from "../../utils/getPrice";
import { AdditionalDocumentationColumns, dataEditVehicleForm, rowsClientDocument, StatementColumns, Tab1Columns, Tab2Columns, Tab3Columns, Tab4Columns, TabAutoColumns, } from "./resources/confirmationFormDto";
import { ConfirmationFormView } from "./ui/view"; /* Beneficiary */
import useBeneficiary from "./components/beneficiary"; /* Insurance */
import useInsurance from "./components/insurance"; /* Vehicle */
import useVehicle from "./components/vehicle"; /* ConfirmationForm */
import useClient from "./components/client"; /* Form Actions */
import useActions from "./components/ui"; /* Selectors */
import useSelectors from "./components/selectors"; /* Functions */
import useFunctions from "./components/functions";
import { PassengerDownloadModal } from "./resources/PassengerDownloadModal";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { ConfirmationHeader } from "./header";
import { useGetInformationSteps } from "../../utils/getInformationStep";
import { useGetSummary } from "../../utils/getSummary";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { formAddBusiness } from "./resources/FormsBusinessDTO";
import { usePremiumCalculate } from "./hook/usePremiumCalculate";
var STEP = STEP_CONFIRMATIONFORM;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var storageKey4 = "afy-steps";
var lsSteps = new LocalStorageService(storageKey4);
var ConfirmationForm = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var permissions = {
        create: hasPermission("sale-confirmation-form-create"),
    };
    // -- DATA & STATES BUSINESS HOME
    var _r = React.useState(false), openModalAddBusiness = _r[0], setOpenModalAddBusiness = _r[1];
    var _s = React.useState(false), showTabRealEstates = _s[0], setShowTabRealEstates = _s[1];
    var _t = useState(formAddBusiness), dataFormBusiness = _t[0], setDataFormBusiness = _t[1];
    var _u = React.useState(false), isCommerce = _u[0], setIsCommerce = _u[1];
    var _v = useState(""), provinceId = _v[0], setProvinceId = _v[1];
    var _w = useState(""), townId = _w[0], setTowId = _w[1];
    var _x = useState(""), sectorId = _x[0], setSectorId = _x[1];
    var _y = useState(""), planCode = _y[0], setPlanCode = _y[1];
    var _z = useState(""), productCode = _z[0], setProductCode = _z[1];
    // HOME
    var _0 = React.useState(false), openModalAddHome = _0[0], setOpenModalAddHome = _0[1];
    var _1 = React.useState(false), showFormBusiness = _1[0], setShowFormBusiness = _1[1];
    // -- END DATA & STATES BUSINESS HOME
    var t = useTranslation().t;
    var classes = useStyles();
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var _2 = React.useState(false), triggerPermissionList = _2[0], setTriggerPermissionList = _2[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _3 = React.useState(lsPageActionFlags.getPageActionFlagsStored()), actionFlags = _3[0], setActionFlags = _3[1];
    var _4 = useState(""), planId = _4[0], setPlanId = _4[1];
    // const [filtersDTO, setFiltersDTO] = useState({});
    var _5 = React.useState(false), openDrawerUpload = _5[0], setOpenDrawerUpload = _5[1];
    var _6 = React.useState(""), idDocumentClient = _6[0], setIdDocumentClient = _6[1];
    var _7 = useState(""), coverTypeId = _7[0], setCoverTypeId = _7[1];
    var _8 = useState(""), campaignId = _8[0], setCampaignId = _8[1];
    var _9 = useState(""), catalogPaymentMode = _9[0], setCatalogPaymentMode = _9[1];
    var _10 = useState(""), catalogStatusQuote = _10[0], setCatalogStatusQuote = _10[1];
    var _11 = useState(""), branchId = _11[0], setBranchId = _11[1];
    var userId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _12 = React.useState(false), uploadTrigger = _12[0], setUploadTrigger = _12[1];
    var isVidaTermino = isCustomer(Customer.VIDA);
    var _13 = React.useState(""), period = _13[0], setPeriod = _13[1];
    var _14 = React.useState([]), breadCrumbs = _14[0], setBreadCrumbs = _14[1];
    var _15 = React.useState(false), showInsured = _15[0], setShowInsured = _15[1];
    var _16 = React.useState(false), showNewFormInsurance = _16[0], setShowNewFormInsurance = _16[1];
    var _17 = React.useState(false), showBeneficiary = _17[0], setShowBeneficiary = _17[1];
    var _18 = React.useState(true), addInsured = _18[0], setAddInsured = _18[1];
    var _19 = React.useState(false), addBeneficiary = _19[0], setAddBeneficiary = _19[1];
    var _20 = React.useState(false), showComponent = _20[0], setShowComponent = _20[1];
    var _21 = useState(false), openModalBackConfirm = _21[0], setOpenModalBackConfirm = _21[1];
    var _22 = React.useState(true), canEdit = _22[0], setCanEdit = _22[1];
    var _23 = React.useState(false), canEditLocation = _23[0], setCanEditLocation = _23[1];
    var _24 = React.useState(false), canEditContact = _24[0], setCanEditContact = _24[1];
    var _25 = React.useState([]), certificates = _25[0], setCertificates = _25[1];
    var _26 = useState([]), rows = _26[0], setRows = _26[1];
    var _27 = useState([]), rows2 = _27[0], setRows2 = _27[1];
    var _28 = useState([]), rowsBeneficiary = _28[0], setRowsBeneficiary = _28[1];
    var _29 = useState([]), rowsPassengers = _29[0], setRowsPassengers = _29[1];
    var _30 = React.useState(false), openActivePolicy = _30[0], setOpenActivePolicy = _30[1];
    var _31 = React.useState(false), showButtonActivatePolicy = _31[0], setShowButtonActivatePolicy = _31[1];
    var _32 = React.useState(""), policyId = _32[0], setPolicyId = _32[1];
    var _33 = React.useState(false), hideMarriedName = _33[0], setHideMarriedName = _33[1];
    var _34 = React.useState(""), namePlan = _34[0], setNamePlan = _34[1];
    var _35 = useState(false), isMaskedDocument = _35[0], setIsMaskedDocument = _35[1];
    var _36 = useState(""), personQuoteId = _36[0], setPersonQuoteId = _36[1];
    var _37 = useState(""), prime = _37[0], setPrime = _37[1];
    var _38 = useState(""), currency = _38[0], setCurrency = _38[1];
    var insuranceType = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name
        ? localStorageService
            .getStepStored()
            .steps[Steps.insurance].name.toLowerCase()
        : "")[0];
    // const [steps, setSteps] = React.useState<MenuItem[]>([]);
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _39 = React.useState(true), enable = _39[0], setEnable = _39[1];
    var _40 = React.useState([]), listIdentificationType = _40[0], setListIdentificationType = _40[1];
    var _41 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _41[0], setSeeToast = _41[1];
    var id = useParams().id;
    var isQuote = useParams().isQuote;
    var isPlan = useParams().isPlan;
    var idProject = useParams().idProject;
    var isDocumentClient = useParams().isDocumentClient;
    var _42 = React.useState(false), projectTrigger = _42[0], setProjectTrigger = _42[1];
    var _43 = React.useState(false), triggerCatalog = _43[0], setTriggerCatalog = _43[1];
    var _44 = React.useState(false), triggerPaymentMode = _44[0], setTriggerPaymentMode = _44[1];
    var _45 = React.useState(false), triggerCertificate = _45[0], setTriggerCertificate = _45[1];
    var _46 = useState([]), listGenders = _46[0], setListGenders = _46[1];
    var _47 = useState(isQuote === "true"), isQuoteType = _47[0], setIsQuoteType = _47[1];
    var _48 = useState(false), canEditBeneficiary = _48[0], setCanEditBeneficiary = _48[1];
    var _49 = useState(false), canEditInsured = _49[0], setCanEditInsured = _49[1];
    var _50 = useState([]), listCountries = _50[0], setListCountries = _50[1];
    var _51 = useState([]), listRegionLevel1 = _51[0], setListRegionLevel1 = _51[1];
    var _52 = useState([]), listRegionLevel2 = _52[0], setListRegionLevel2 = _52[1];
    var _53 = useState([]), listRegionLevel3 = _53[0], setListRegionLevel3 = _53[1];
    var _54 = React.useState(1), page = _54[0], setPage = _54[1];
    var _55 = React.useState(""), idQuoteVehicle = _55[0], setIdQuoteVehicle = _55[1];
    var _56 = React.useState(""), productId = _56[0], setProductId = _56[1];
    var _57 = React.useState(10000), limit = _57[0], setLimit = _57[1];
    var _58 = React.useState(false), openModal = _58[0], setOpenModal = _58[1];
    var _59 = React.useState(false), openModalAddInsurance = _59[0], setOpenModalAddInsurance = _59[1];
    var _60 = React.useState(false), openModalPdfViewer = _60[0], setopenModalPdfViewer = _60[1];
    var _61 = React.useState(""), urlDocument = _61[0], setUrlDocument = _61[1];
    var _62 = React.useState(""), nameDocument = _62[0], setNameDocument = _62[1];
    var _63 = React.useState(""), personId = _63[0], setPersonId = _63[1];
    var _64 = React.useState(false), openModalBeneficiary = _64[0], setOpenModalBeneficiary = _64[1];
    var _65 = React.useState(transformToSelect(localStorageService.getStepStored().steps[Steps.plan].paymentMode)), paymentMode = _65[0], setPaymentMode = _65[1];
    var _66 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), coverageType = _66[0], setCoverageType = _66[1];
    var _67 = React.useState([
        { id: 1, name: "Sin datos", value: "-1", code: "" },
    ]), insuredType = _67[0], setInsuredType = _67[1];
    var _68 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), beneficiaryType = _68[0], setBeneficiaryType = _68[1];
    var _69 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaign = _69[0], setCampaign = _69[1];
    var _70 = React.useState(""), planName = _70[0], setPlanName = _70[1];
    var _71 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaigns = _71[0], setCampaigns = _71[1];
    var _72 = React.useState({
        id: (_b = (_a = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
        name: (_d = (_c = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        value: (_f = (_e = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : "",
    }), campaignSelected = _72[0], setCampaignSelected = _72[1];
    var _73 = React.useState({
        id: localStorageService.getStepStored().steps[Steps.customer].id,
        name: localStorageService.getStepStored().steps[Steps.customer].name,
    }), plan = _73[0], setPlan = _73[1];
    var _74 = React.useState(), paymentSelected = _74[0], setPaymentSelected = _74[1];
    var _75 = React.useState(), planSelected = _75[0], setPlanSelected = _75[1];
    var _76 = React.useState(false), openModalEditVehicle = _76[0], setOpenModalEditVehicle = _76[1];
    var steps = useGetSteps();
    var _77 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), planData = _77[0], setPlanData = _77[1];
    var _78 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaignInfo = _78[0], setCampaignInfo = _78[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var level4 = "REGION_LEVEL4";
    var _79 = React.useState(), coverType = _79[0], setCoverType = _79[1];
    var _80 = useState("Confirmación de Datos"), titleInsured = _80[0], setTitleInsured = _80[1];
    var _81 = useState("Ingresar beneficiario"), titleBeneficiary = _81[0], setTitleBeneficiary = _81[1];
    var _82 = React.useState(findParamInLocalStorage("projectId") || ""), projectId = _82[0], setProjectId = _82[1];
    var _83 = React.useState(false), isTravelInsurance = _83[0], setIsTravelInsurance = _83[1];
    // Get passenger counts from localStorage and calculate sum
    var edad020 = parseInt(findParamInLocalStorage("edad020") || "0");
    var edad2174 = parseInt(findParamInLocalStorage("edad2174") || "0");
    var edad7585 = parseInt(findParamInLocalStorage("edad7585") || "0");
    var _84 = React.useState(edad020 + edad2174 + edad7585), premiumSum = _84[0], setPremiumSum = _84[1];
    var _85 = useState(false), isUpdate = _85[0], setIsUpdate = _85[1];
    var _86 = React.useState(dataEditVehicleForm), dataFormVehicle = _86[0], setDataFormVehicle = _86[1];
    var _87 = useState({
        DocumentNumber: "",
        QuoteNumber: "",
        QuoteStatusName: "",
        QuoteDate: "",
        Type: "",
        PlanTypeName: "",
        CampaignName: "-",
        IdTypeName: "",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        SecondLastName: "",
        MarriedSurName: "-",
        Gender: "",
        Birthday: "",
        Address1: "-",
        Address2: "-",
        CountryName: "",
        ProvinceName: "",
        TownName: "",
        SectorName: "",
        PostalCode: "",
        PhoneOffice: "",
        PhoneHome: "-",
        PhoneNumber: "-",
        Email: "",
    }), dataForm = _87[0], setDataForm = _87[1];
    var _88 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        Percentage: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormBeneficiary = _88[0], setDataFormBeneficiary = _88[1];
    var _89 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormInsurance = _89[0], setDataFormInsurance = _89[1];
    var _90 = useState({
        idInsuredType: "f97da54f-2ee9-4bca-8063-596b74057e34",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        IdType: "",
        DocumentNumber: "",
        Birthday: "",
        Gender: "",
        MarriedSurName: "",
        Country: "99377891-b77a-42e2-9b84-803d1d5761d1",
        Province: "",
        Town: "",
        Sector: "",
        PostalCode: "",
        Address1: "",
        PhoneHome: "",
        PhoneNumber: "",
        PhoneOffice: "",
        Email: "",
    }), dataFormInsuranceSp = _90[0], setDataFormInsuranceSp = _90[1];
    var _91 = useState(45), initialPercentage = _91[0], setInitialPercentage = _91[1];
    var _92 = useState(false), trigger = _92[0], setTrigger = _92[1];
    var _93 = useState(), document = _93[0], setDocument = _93[1];
    var _94 = useState(false), isInsurance = _94[0], setIsInsurance = _94[1];
    var _95 = useState([]), listVehiclesDetail = _95[0], setListVehicles = _95[1];
    var _96 = React.useState({}), salesFlow = _96[0], setSalesFlow = _96[1];
    var _97 = React.useState([]), statementRows = _97[0], setStatementRows = _97[1];
    var _98 = React.useState([]), filters = _98[0], setFilters = _98[1];
    var _99 = React.useState([]), defaultFilters = _99[0], setDefaultFilters = _99[1];
    var _100 = React.useState(rowsClientDocument), profileDocumentsRows = _100[0], setProfileDocumentsRows = _100[1];
    var _101 = React.useState(0), countBadge = _101[0], setCountBadge = _101[1];
    var carDetails = React.useState((_g = lsSteps.getStepStored().steps[Steps.vehiclesDetails]) === null || _g === void 0 ? void 0 : _g.vehiclesDetails)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var isApapAuto = getCustomerAction().customerAuto.includes(company);
    var hideTabDocumentClient = isApapAuto && (isQuote === "true" || isQuote === undefined);
    var isNotQuote = isQuote !== "false";
    var isApapAutoWithoutQuote = isApapAuto && !isNotQuote;
    var _102 = React.useState(""), fileName = _102[0], setFileName = _102[1];
    var _103 = React.useState(), pdfFile = _103[0], setPdfFile = _103[1];
    var _104 = React.useState(false), modalDocumentClient = _104[0], setModalDocumentClient = _104[1];
    var _105 = React.useState(""), urlDocumentClient = _105[0], setUrlDocumentClient = _105[1];
    var _106 = React.useState("false"), docName = _106[0], setDocName = _106[1];
    var _107 = React.useState(false), openModalPassenger = _107[0], setOpenModalPassenger = _107[1];
    var _108 = React.useState(""), urlDocumentPassenger = _108[0], setUrlDocumentPassenger = _108[1];
    var _109 = React.useState(""), nameDocumentPassenger = _109[0], setNameDocumentPassenger = _109[1];
    var _110 = React.useState(((_h = localStorageService.getStepStored().steps[Steps.customer]) === null || _h === void 0 ? void 0 : _h.paymentModeSelected) || { id: "", name: "", value: "" }), paymentModelSelected = _110[0], setPaymentModelSelected = _110[1];
    var _111 = React.useState(localStorageService.getStepStored().steps[Steps.customer].coverType), coverTypeSelected = _111[0], setCoverTypeSelected = _111[1];
    var _112 = useState(""), productType = _112[0], setProductType = _112[1];
    var projectTypeLocal = React.useRef((_k = (_j = lsSteps.getStepStored().steps[Steps.insurance].flow) === null || _j === void 0 ? void 0 : _j.metadata) === null || _k === void 0 ? void 0 : _k.navigation.productType);
    var _113 = useState(""), quoteId = _113[0], setQuoteId = _113[1];
    var isApap = getCustomerAction().customerAuto.includes(company);
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteIdLS = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _114 = React.useState({}), sessionData = _114[0], setSessionData = _114[1];
    var _115 = useStepNavigation({
        currentStepId: pathname,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _115.navigation, isNextDisabled = _115.isNextDisabled, validationResult = _115.validationResult;
    var _116 = useGetInformationSteps(pathLocation), instanceId = _116.instanceId, workFlowId = _116.workFlowId, currentStep = _116.currentStep, nextStep = _116.nextStep;
    // Ref para controlar si ya se inicializó el país una vez
    var countryInitializedRef = React.useRef(false);
    //HOOKS NEGOCIO PROTEGIDO - CONFIRMATION FORM
    var _117 = usePremiumCalculate(), loadingCalculate = _117.loadingCalculate, responseCalculate = _117.responseCalculate, errorCalculate = _117.errorCalculate, onCalculateRate = _117.onCalculateRate, damageBackup = _117.damageBackup, insuredProperty = _117.insuredProperty;
    var _118 = useSelectors(), loadingUpdateQuote = _118.loadingUpdateQuote, errorUpdateQuote = _118.errorUpdateQuote, responseIdentificationType = _118.responseIdentificationType, errorIdentificationType = _118.errorIdentificationType, responseCatalogGender = _118.responseCatalogGender, errorCatalogGender = _118.errorCatalogGender, responsePlan = _118.responsePlan, errorPlan = _118.errorPlan, loading = _118.loading, responseCountries = _118.responseCountries, errorCountries = _118.errorCountries, responseRegion = _118.responseRegion, errorRegion = _118.errorRegion, responsePlans = _118.responsePlans, errorPlans = _118.errorPlans, loadingPlans = _118.loadingPlans, responseInsured = _118.responseInsured, errorInsured = _118.errorInsured, responsePostInsured = _118.responsePostInsured, errorPostInsured = _118.errorPostInsured, loadingPostInsured = _118.loadingPostInsured, responsePatchInsured = _118.responsePatchInsured, errorPatchInsured = _118.errorPatchInsured, loadingPatchInsured = _118.loadingPatchInsured, responseUpdatePerson = _118.responseUpdatePerson, errorUpdatePerson = _118.errorUpdatePerson, loadingUpdatePerson = _118.loadingUpdatePerson, responseBenefit = _118.responseBenefit, errorBenefit = _118.errorBenefit, loadingBenefit = _118.loadingBenefit, responsePatchBeneficiary = _118.responsePatchBeneficiary, errorPatchBeneficiary = _118.errorPatchBeneficiary, loadingPatchBeneficiary = _118.loadingPatchBeneficiary, responseBeneficiary = _118.responseBeneficiary, errorBeneficiary = _118.errorBeneficiary, loadingBeneficiary = _118.loadingBeneficiary, responsePageActionFlags = _118.responsePageActionFlags, responseOneProject = _118.responseOneProject, loadingOneProject = _118.loadingOneProject, errorOneQuote = _118.errorOneQuote, responseOneQuote = _118.responseOneQuote, loadingOneQuote = _118.loadingOneQuote, loadingInsured = _118.loadingInsured;
    var updateVehicle = useVehicle(setOpenModalEditVehicle).updateVehicle;
    var _119 = useClient(paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPaymentSelected, setPlanSelected, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance, setShowTabRealEstates, setShowFormBusiness), searchPerson = _119.searchPerson, handleSearch = _119.handleSearch, callDispatchPlan = _119.callDispatchPlan, callDispatchPlanAfterQuoteLoaded = _119.callDispatchPlanAfterQuoteLoaded, handleOnChangePaymentMethod = _119.handleOnChangePaymentMethod, handleOnChangeCoverType = _119.handleOnChangeCoverType, handleOnChangeCampaign = _119.handleOnChangeCampaign, handleChangeSelect = _119.handleChangeSelect, handleChangeSelectFormInsurance = _119.handleChangeSelectFormInsurance, handleUpdatePerson = _119.handleUpdatePerson, handleDownload = _119.handleDownload, updateDataFormPerson = _119.updateDataFormPerson, setCoverTypeStorybook = _119.setCoverTypeStorybook, handleOnClickAcquire = _119.handleOnClickAcquire, quoteUploadDocuments = _119.quoteUploadDocuments, callQuoteOne = _119.callQuoteOne, getActionFlags = _119.getActionFlags, handleOnClickAutoDownload = _119.handleOnClickAutoDownload, handleOnClickAutoDownloadVida = _119.handleOnClickAutoDownloadVida, setLocalStorage = _119.setLocalStorage, callDispatchPageActionFlags = _119.callDispatchPageActionFlags, showVehicleData = _119.showVehicleData, showDownloadQuote = _119.showDownloadQuote, showDownloadRequest = _119.showDownloadRequest;
    var _120 = useInsurance(setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, setRows, responseOneQuote, quoteId ? quoteId : id, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredType, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast), handleAddInsured = _120.handleAddInsured, setInsuranceStorybook = _120.setInsuranceStorybook, handleSubmitInsured = _120.handleSubmitInsured, editInsured = _120.editInsured, searchInsurancePerson = _120.searchInsurancePerson;
    var _121 = useBeneficiary(setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType), setBeneficiaryStorybook = _121.setBeneficiaryStorybook, handleAddBeneficiary = _121.handleAddBeneficiary, handleSubmitBeneficiary = _121.handleSubmitBeneficiary, getInsuredBeneficiary = _121.getInsuredBeneficiary, editBeneficiary = _121.editBeneficiary;
    var _122 = useActions(setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, pathLocation, navigation), handleNext = _122.handleNext, handlePrevious = _122.handlePrevious, onClickBack = _122.onClickBack, handleCloseBackModal = _122.handleCloseBackModal, handleBackFromModal = _122.handleBackFromModal, handleClickContextMenu = _122.handleClickContextMenu, loadingComplete = _122.loadingComplete;
    var filterData = useFunctions().filterData;
    var _123 = useCertificateQuote(triggerCertificate, "cotizacion", quoteId, 1, 20), responseCertificateQuote = _123.responseCertificateQuote, errorCertificateQuote = _123.errorCertificateQuote, loadingCertificateQuote = _123.loadingCertificateQuote;
    var _124 = PostUploadDocuments(uploadTrigger, id ? id : quoteId, fileName, pdfFile, idDocumentClient), responseUploadDocuments = _124.responseUploadDocuments, errorUploadDocuments = _124.errorUploadDocuments, loadingUploadDocuments = _124.loadingUploadDocuments;
    var _125 = GetCatalogBeneficiary(triggerCatalog, enable, page, limit, clientId), responseGetCatalogBeneficiary = _125.responseGetCatalogBeneficiary, errorGetCatalogBeneficiary = _125.errorGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _125.loadingGetCatalogBeneficiary;
    var _126 = GetCatalogInsurance(triggerCatalog, enable, page, limit, clientId), responseGetCatalogInsurance = _126.responseGetCatalogInsurance, errorGetCatalogInsurance = _126.errorGetCatalogInsurance, loadingGetCatalogInsurance = _126.loadingGetCatalogInsurance;
    var _127 = GetPersonByDocument(trigger, document), responsePersonByDocument = _127.responsePersonByDocument, errorPersonByDocument = _127.errorPersonByDocument, loadingPersonByDocument = _127.loadingPersonByDocument;
    var _128 = GetPaymentMode(triggerPaymentMode, projectId || idProject || ""), responsePaymentMode = _128.responsePaymentMode, errorPaymentMode = _128.errorPaymentMode, loadingPaymentMode = _128.loadingPaymentMode;
    var onSameDirection = function (checked, data) {
        var _a;
        if (data === "sameAddress") {
            if (checked === true) {
                var addressFromQuote_1 = ((_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.address1) || "";
                setDataFormBusiness(function (prev) { return ({
                    Province: provinceId,
                    Town: townId,
                    Sector: sectorId,
                    propertyAddress: addressFromQuote_1,
                }); });
            }
            else {
                setDataFormBusiness(function (prev) { return ({
                    Province: "",
                    Town: "",
                    Sector: "",
                    propertyAddress: "",
                }); });
            }
        }
    };
    useEffect(function () {
        var _a;
        // Clear PageActionFlags redux state on first load
        dispatch(pageActionFlagsClearData());
        // Remove summary from localStorage if coming from insurancePoliciesSummary
        if (idProject) {
            console.log("Removing summary from localStorage - coming from insurancePoliciesSummary");
            localStorage.removeItem("summary");
        }
        setProjectTrigger(true);
        if (idProject || projectId) {
            dispatch(projectOne({
                id: idProject ? idProject : projectId,
            }));
        }
        setTriggerCatalog(true);
        setTriggerPaymentMode(true);
        getActionFlags();
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
        //Get Quote //
        var quoteIdLs = quoteIdLS;
        if (id !== undefined) {
            dispatch(quoteClearData());
            setCanEdit(isQuoteType);
            if (!isQuoteType) {
                setCanEditLocation(true);
                setCanEditContact(true);
            }
            //Get the quote by id
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteIdLs);
        }
        callGetInsuredBeneficiary((_a = id !== null && id !== void 0 ? id : quoteIdLs) !== null && _a !== void 0 ? _a : "");
        // Note: callDispatchPlan moved to useEffect that waits for responseOneQuote
        //if (permissionList?.length === 0) {
        //setTriggerPermissionList(true);
        //}
        //if (permissionList?.length === 0) {
        //setTriggerPermissionList(true);
        console.log("isQuoteType---", isQuoteType);
        //}
    }, []);
    /* Handle Errors */
    useEffect(function () {
        if (errorPersonByDocument) {
            showErrorToast(errorPersonByDocument, setSeeToast, t);
        }
    }, [errorPersonByDocument]);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        if (errorInsured) {
            showErrorToast(errorInsured, setSeeToast, t);
        }
    }, [errorInsured]);
    useEffect(function () {
        if (errorCatalogGender) {
            showErrorToast(errorCatalogGender, setSeeToast, t);
        }
    }, [errorCatalogGender]);
    useEffect(function () {
        if (errorCountries) {
            showErrorToast(errorCountries, setSeeToast, t);
        }
    }, [errorCountries]);
    useEffect(function () {
        if (errorRegion) {
            showErrorToast(errorRegion, setSeeToast, t);
        }
    }, [errorRegion]);
    useEffect(function () {
        if (errorUpdateQuote) {
            showErrorToast(errorUpdateQuote, setSeeToast, t);
        }
    }, [errorUpdateQuote]);
    useEffect(function () {
        if (errorPlan) {
            showErrorToast(errorPlan, setSeeToast, t);
        }
    }, [errorPlan]);
    useEffect(function () {
        if (errorBeneficiary) {
            showErrorToast(errorBeneficiary, setSeeToast, t);
        }
    }, [errorBeneficiary]);
    useEffect(function () {
        if (errorIdentificationType) {
            showErrorToast(errorIdentificationType, setSeeToast, t);
        }
    }, [errorIdentificationType]);
    useEffect(function () {
        if (errorUpdatePerson) {
            showErrorToast(errorUpdatePerson, setSeeToast, t);
        }
    }, [errorUpdatePerson]);
    useEffect(function () {
        if (errorPatchBeneficiary) {
            showErrorToast(errorPatchBeneficiary, setSeeToast, t);
            dispatch(patchBeneficiaryClearData());
        }
    }, [errorPatchBeneficiary]);
    useEffect(function () {
        if (errorPatchInsured) {
            showErrorToast(errorPatchInsured, setSeeToast, t);
            dispatch(patchInsuredClearData());
        }
    }, [errorPatchInsured]);
    useEffect(function () {
        if (errorBenefit) {
            showErrorToast(errorBenefit, setSeeToast, t);
            dispatch(benefitClearData());
        }
    }, [errorBenefit]);
    useEffect(function () {
        if (errorPostInsured) {
            showErrorToast(errorPostInsured, setSeeToast, t);
            dispatch(postInsuredClearData());
        }
    }, [errorPostInsured]);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    useEffect(function () {
        if (errorUploadDocuments) {
            showErrorToast(errorUploadDocuments, setSeeToast, t);
        }
    }, [errorUploadDocuments]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePaymentMode && responsePaymentMode.length > 0) {
            // Transform payment mode response to select format
            var paymentModeList_1 = [];
            var quotePaymentModeId_1 = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
            responsePaymentMode.map(function (item) {
                var _a, _b, _c, _d;
                var itemId = ((_a = item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id) || item.id;
                paymentModeList_1.push({
                    id: itemId,
                    name: ((_b = item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description) || item.description || "",
                    value: ((_c = item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code) ||
                        ((_d = item.catalogPaymentMode) === null || _d === void 0 ? void 0 : _d.id) ||
                        item.id,
                    default: quotePaymentModeId_1 ? itemId === quotePaymentModeId_1 : false,
                });
            });
            setPaymentMode(paymentModeList_1);
            // Set initial payment mode selection only if not already set and no quote data available
            if (!(paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                paymentModeList_1.length > 0 &&
                !((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogPaymentMode)) {
                setPaymentModelSelected(paymentModeList_1[0]);
                // Set initial period when payment mode is first loaded
                setPeriod(paymentModeList_1[0].name);
            }
        }
    }, [responsePaymentMode, (_m = (_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.catalogPaymentMode) === null || _m === void 0 ? void 0 : _m.id]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var combustionMap = {
                GASOLINE: "Gasolina",
                DIESEL: "Diesel",
                ELECTRIC: "Eléctrico",
                GAS: "Gas",
            };
            var combustionType = (_a = responseOneQuote.data.contentMap) === null || _a === void 0 ? void 0 : _a.combustion;
            var carCombustion = combustionMap[combustionType] || "";
            var price = parsePrice(((_b = responseOneQuote.data.contentMap) === null || _b === void 0 ? void 0 : _b.deductibleTypeId) || 0);
            var newPrice = formatNumberCustom(price || 0);
            var car = {
                id: 1,
                brand: (_d = (_c = responseOneQuote.data.contentMap) === null || _c === void 0 ? void 0 : _c.brand) === null || _d === void 0 ? void 0 : _d.name,
                model: (_f = (_e = responseOneQuote.data.contentMap) === null || _e === void 0 ? void 0 : _e.model) === null || _f === void 0 ? void 0 : _f.name,
                fueltype: carCombustion,
                color: (_h = (_g = responseOneQuote.data.contentMap) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.name,
                price: "RD$ ".concat(newPrice),
                cylinders: (_j = responseOneQuote.data.contentMap) === null || _j === void 0 ? void 0 : _j.cylinders,
                plate: (_k = responseOneQuote.data.contentMap) === null || _k === void 0 ? void 0 : _k.plate,
            };
            var vehicleDet = [];
            vehicleDet.push(car);
            setListVehicles(vehicleDet);
        }
    }, [responseOneQuote]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseCertificateQuote && ((_a = responseCertificateQuote.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var urlC = (_b = responseCertificateQuote.data[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (urlC) {
                setUrlDocument(urlC);
                setNameDocument((_c = responseCertificateQuote.data[0]) === null || _c === void 0 ? void 0 : _c.title);
                setopenModalPdfViewer(true);
            }
            setTriggerCertificate(false);
            dispatch(certificateQuoteClearData());
        }
        else if (responseCertificateQuote &&
            ((_d = responseCertificateQuote.data) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            setTriggerCertificate(false);
            showToastSuccessMessage("No se encontro ningun documento adjunto.", typeAlert.warning, setSeeToast);
            dispatch(certificateQuoteClearData());
        }
    }, [responseCertificateQuote]);
    useEffect(function () {
        if (errorCertificateQuote) {
            showErrorToast(errorCertificateQuote, setSeeToast, t);
        }
    }, [errorCertificateQuote]);
    // determina con que servicio iniciar el formulario de negocio
    useEffect(function () {
        if (planName) {
            var isCommerceValue_1 = planName.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue_1);
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: isCommerceValue_1 ? "1" : "2" })); });
        }
    }, [planName]);
    useEffect(function () {
        // Solo setear el país una vez cuando listCountries se cargue por primera vez
        if (listCountries.length > 0 && !countryInitializedRef.current) {
            var countryId_1 = getLogin().countryId || "";
            if (countryId_1) {
                setDataFormInsuranceSp(function (prev) { return (__assign(__assign({}, prev), { Country: countryId_1 })); });
                countryInitializedRef.current = true;
            }
        }
    }, [listCountries]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setProvinceId((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.province.id);
            setTowId((_b = responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.municipality.id);
            setSectorId((_c = responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.district.id);
            setPlanCode(((_d = responseOneQuote.data) === null || _d === void 0 ? void 0 : _d.planId.code) || "");
            setProductCode(((_e = responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.productId.code) || "");
            setPersonQuoteId((_f = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _f === void 0 ? void 0 : _f.personId);
            setQuoteId((_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.id);
            setPlanId((_j = (_h = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.planId) === null || _j === void 0 ? void 0 : _j.id);
            setCoverTypeId((_l = (_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.coverType) === null || _l === void 0 ? void 0 : _l.id);
            setCampaignId((_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.campaignId) === null || _o === void 0 ? void 0 : _o.id);
            setCatalogPaymentMode((_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.catalogPaymentMode) === null || _q === void 0 ? void 0 : _q.id);
            setShowButtonActivatePolicy(((_t = (_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.policyId) === null || _s === void 0 ? void 0 : _s.policyStatus) === null || _t === void 0 ? void 0 : _t.description) ===
                "Pendiente" ||
                ((_w = (_v = (_u = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _u === void 0 ? void 0 : _u.policyId) === null || _v === void 0 ? void 0 : _v.policyStatus) === null || _w === void 0 ? void 0 : _w.description) ===
                    "pendiente");
            setPolicyId((_y = (_x = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.policyId) === null || _y === void 0 ? void 0 : _y.id);
            // Update paymentModelSelected with the catalogPaymentMode from quote
            if ((_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.catalogPaymentMode) {
                var selectedPaymentMode = {
                    id: responseOneQuote.data.catalogPaymentMode.id,
                    name: responseOneQuote.data.catalogPaymentMode.description,
                    value: responseOneQuote.data.catalogPaymentMode.code ||
                        responseOneQuote.data.catalogPaymentMode.id,
                    label: responseOneQuote.data.catalogPaymentMode.description,
                };
                setPaymentModelSelected(selectedPaymentMode);
                // Set period from quote data
                setPeriod(responseOneQuote.data.catalogPaymentMode.description);
                // Update paymentMode array to mark the correct option as default
                if (paymentMode.length > 0) {
                    var updatedPaymentMode = paymentMode.map(function (mode) { return (__assign(__assign({}, mode), { default: mode.id === responseOneQuote.data.catalogPaymentMode.id })); });
                    setPaymentMode(updatedPaymentMode);
                }
            }
            setCatalogStatusQuote((_1 = (_0 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _0 === void 0 ? void 0 : _0.catalogStatusQuote) === null || _1 === void 0 ? void 0 : _1.id);
            setBranchId((_2 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _2 === void 0 ? void 0 : _2.branch);
            setPlanName((_4 = (_3 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _3 === void 0 ? void 0 : _3.planId) === null || _4 === void 0 ? void 0 : _4.name);
            // getInsuredBeneficiary();
            var gender = listGenders.find(function (g) { var _a, _b; return g.id === ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogGender) === null || _b === void 0 ? void 0 : _b.id); });
            var HideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true;
            setHideMarriedName(HideMarriedName);
            /*date = formattedDate(date);*/
            //Province
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //Municipality
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level2,
                parentRegionId: (_6 = (_5 = responseOneQuote.data) === null || _5 === void 0 ? void 0 : _5.municipality) === null || _6 === void 0 ? void 0 : _6.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //District
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level3,
                parentRegionId: (_8 = (_7 = responseOneQuote.data) === null || _7 === void 0 ? void 0 : _7.district) === null || _8 === void 0 ? void 0 : _8.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            var status = (_10 = (_9 = responseOneQuote.data) === null || _9 === void 0 ? void 0 : _9.catalogStatusQuote) === null || _10 === void 0 ? void 0 : _10.description;
            if (status == "Cancelada") {
                status = "Fecha de cancelación";
            }
            else if (status == "Emitida") {
                status = "Fecha de emisión";
            }
            else if (status == "Expirada") {
                status = "Fecha de expiración";
            }
            else {
                status = "Fecha de cotización";
            }
            var date = ((_12 = (_11 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _11 === void 0 ? void 0 : _11.policyId) === null || _12 === void 0 ? void 0 : _12.effectiveFrom) ||
                ((_13 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _13 === void 0 ? void 0 : _13.creationDate);
            var nextYearDate = undefined;
            var originalDate = void 0;
            if (date) {
                var originalDate_1 = new Date(date);
                originalDate_1.setFullYear(originalDate_1.getFullYear() + 1);
                nextYearDate = formattedDate(originalDate_1.toISOString());
                nextYearDate = originalDate_1.toISOString();
            }
            setDataForm({
                DocumentNumber: formatDocument(responseOneQuote && ((_14 = responseOneQuote.data) === null || _14 === void 0 ? void 0 : _14.numberId)),
                IdType: ((_16 = (_15 = responseOneQuote.data) === null || _15 === void 0 ? void 0 : _15.identificationTypeId) === null || _16 === void 0 ? void 0 : _16.id)
                    ? (_18 = (_17 = responseOneQuote.data) === null || _17 === void 0 ? void 0 : _17.identificationTypeId) === null || _18 === void 0 ? void 0 : _18.id
                    : "",
                Type: responseOneQuote &&
                    ((_20 = (_19 = responseOneQuote.data) === null || _19 === void 0 ? void 0 : _19.identificationTypeId) === null || _20 === void 0 ? void 0 : _20.description),
                QuoteNumber: ((_21 = responseOneQuote.data) === null || _21 === void 0 ? void 0 : _21.policyId)
                    ? (_22 = responseOneQuote.data) === null || _22 === void 0 ? void 0 : _22.policyId.code
                    : responseOneQuote && ((_23 = responseOneQuote.data) === null || _23 === void 0 ? void 0 : _23.code),
                Name: responseOneQuote && ((_24 = responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.firstNameA),
                SecondName: responseOneQuote && ((_25 = responseOneQuote.data) === null || _25 === void 0 ? void 0 : _25.firstNameB),
                FirstLastName: responseOneQuote && ((_26 = responseOneQuote.data) === null || _26 === void 0 ? void 0 : _26.lastNameA),
                SecondLastName: responseOneQuote && ((_27 = responseOneQuote.data) === null || _27 === void 0 ? void 0 : _27.lastNameB),
                MarriedSurName: responseOneQuote && ((_28 = responseOneQuote.data) === null || _28 === void 0 ? void 0 : _28.marriedName),
                Birthday: responseOneQuote && ((_29 = responseOneQuote.data) === null || _29 === void 0 ? void 0 : _29.dob),
                Address1: responseOneQuote && ((_30 = responseOneQuote.data) === null || _30 === void 0 ? void 0 : _30.address1),
                Address2: responseOneQuote && ((_31 = responseOneQuote.data) === null || _31 === void 0 ? void 0 : _31.address2),
                PhoneOffice: responseOneQuote && formatPhoneNumber((_32 = responseOneQuote.data) === null || _32 === void 0 ? void 0 : _32.phone2),
                PhoneHome: responseOneQuote && formatPhoneNumber((_33 = responseOneQuote.data) === null || _33 === void 0 ? void 0 : _33.phone1),
                PhoneNumber: responseOneQuote && formatPhoneNumber((_34 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _34 === void 0 ? void 0 : _34.phone3),
                Email: responseOneQuote && ((_35 = responseOneQuote.data) === null || _35 === void 0 ? void 0 : _35.email),
                QuoteStatusName: responseOneQuote &&
                    ((_37 = (_36 = responseOneQuote.data) === null || _36 === void 0 ? void 0 : _36.catalogStatusQuote) === null || _37 === void 0 ? void 0 : _37.description),
                QuoteDate: date,
                effectiveDate: responseOneQuote && ((_38 = responseOneQuote.data) === null || _38 === void 0 ? void 0 : _38.policyId)
                    ? nextYearDate
                    : "",
                PlanTypeName: responseOneQuote && ((_40 = (_39 = responseOneQuote.data) === null || _39 === void 0 ? void 0 : _39.planId) === null || _40 === void 0 ? void 0 : _40.name),
                CampaignName: responseOneQuote && ((_42 = (_41 = responseOneQuote.data) === null || _41 === void 0 ? void 0 : _41.campaignId) === null || _42 === void 0 ? void 0 : _42.name),
                IdTypeName: responseOneQuote &&
                    ((_44 = (_43 = responseOneQuote.data) === null || _43 === void 0 ? void 0 : _43.identificationTypeId) === null || _44 === void 0 ? void 0 : _44.description),
                Gender: responseOneQuote && ((_46 = (_45 = responseOneQuote.data) === null || _45 === void 0 ? void 0 : _45.catalogGender) === null || _46 === void 0 ? void 0 : _46.id),
                Country: responseOneQuote && ((_48 = (_47 = responseOneQuote.data) === null || _47 === void 0 ? void 0 : _47.nationality) === null || _48 === void 0 ? void 0 : _48.id),
                CountryName: responseOneQuote && ((_50 = (_49 = responseOneQuote.data) === null || _49 === void 0 ? void 0 : _49.nationality) === null || _50 === void 0 ? void 0 : _50.name),
                Province: responseOneQuote && ((_52 = (_51 = responseOneQuote.data) === null || _51 === void 0 ? void 0 : _51.province) === null || _52 === void 0 ? void 0 : _52.id),
                ProvinceName: responseOneQuote && ((_54 = (_53 = responseOneQuote.data) === null || _53 === void 0 ? void 0 : _53.province) === null || _54 === void 0 ? void 0 : _54.name),
                TownName: responseOneQuote && ((_56 = (_55 = responseOneQuote.data) === null || _55 === void 0 ? void 0 : _55.municipality) === null || _56 === void 0 ? void 0 : _56.name),
                Town: responseOneQuote && ((_58 = (_57 = responseOneQuote.data) === null || _57 === void 0 ? void 0 : _57.municipality) === null || _58 === void 0 ? void 0 : _58.id),
                Sector: responseOneQuote && ((_60 = (_59 = responseOneQuote.data) === null || _59 === void 0 ? void 0 : _59.district) === null || _60 === void 0 ? void 0 : _60.id),
                SectorName: responseOneQuote && ((_62 = (_61 = responseOneQuote.data) === null || _61 === void 0 ? void 0 : _61.district) === null || _62 === void 0 ? void 0 : _62.name),
                PostalCode: responseOneQuote && ((_63 = responseOneQuote.data) === null || _63 === void 0 ? void 0 : _63.zip),
            });
            //setFormVehicle
            setIdQuoteVehicle((_65 = (_64 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _64 === void 0 ? void 0 : _64.contentMap) === null || _65 === void 0 ? void 0 : _65.idquoteVehicle);
            setProductId((_67 = (_66 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _66 === void 0 ? void 0 : _66.productId) === null || _67 === void 0 ? void 0 : _67.id);
            var carConditionName = void 0;
            switch ((_69 = (_68 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _68 === void 0 ? void 0 : _68.contentMap) === null || _69 === void 0 ? void 0 : _69.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            if ((_70 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _70 === void 0 ? void 0 : _70.profileDocuments) {
                var pendingCount = responseOneQuote.data.profileDocuments.filter(function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.status) === "PENDING"; }).length;
                setCountBadge(pendingCount);
                var dataRows = (_72 = (_71 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _71 === void 0 ? void 0 : _71.profileDocuments) === null || _72 === void 0 ? void 0 : _72.map(function (item) {
                    var _a;
                    return ({
                        id: item.id,
                        docType: item.name,
                        state: (function () {
                            switch (item.status) {
                                case "PENDING":
                                    return "Pendiente";
                                case "READY":
                                    return "Listo";
                            }
                        })(),
                        date: "",
                        user: "",
                        documentClientUrl: ((_a = item.document) === null || _a === void 0 ? void 0 : _a.path) || "",
                    });
                });
                setProfileDocumentsRows(dataRows);
            }
            var fuelTypeName = void 0;
            switch ((_74 = (_73 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _73 === void 0 ? void 0 : _73.contentMap) === null || _74 === void 0 ? void 0 : _74.combustion) {
                case "GAS":
                    fuelTypeName = "Gas";
                    break;
                case "ELECTRIC":
                    fuelTypeName = "Eléctrico";
                    break;
                case "DIESEL":
                    fuelTypeName = "Diesel";
                    break;
                case "GASOLINE":
                    fuelTypeName = "Gasolina";
                    break;
            }
            var countChassis = ((_76 = (_75 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _75 === void 0 ? void 0 : _75.contentMap) === null || _76 === void 0 ? void 0 : _76.chassisNumber) || "";
            var isChassisValid = (countChassis === null || countChassis === void 0 ? void 0 : countChassis.length) !== 17;
            setDataFormVehicle({
                carDetails: [
                    {
                        brand: {
                            id: (_79 = (_78 = (_77 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _77 === void 0 ? void 0 : _77.contentMap) === null || _78 === void 0 ? void 0 : _78.brand) === null || _79 === void 0 ? void 0 : _79.id,
                            name: (_82 = (_81 = (_80 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _80 === void 0 ? void 0 : _80.contentMap) === null || _81 === void 0 ? void 0 : _81.brand) === null || _82 === void 0 ? void 0 : _82.name,
                        },
                        model: {
                            id: (_85 = (_84 = (_83 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _83 === void 0 ? void 0 : _83.contentMap) === null || _84 === void 0 ? void 0 : _84.model) === null || _85 === void 0 ? void 0 : _85.id,
                            name: (_88 = (_87 = (_86 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _86 === void 0 ? void 0 : _86.contentMap) === null || _87 === void 0 ? void 0 : _87.model) === null || _88 === void 0 ? void 0 : _88.name,
                        },
                        version: {
                            id: (_91 = (_90 = (_89 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _89 === void 0 ? void 0 : _89.contentMap) === null || _90 === void 0 ? void 0 : _90.version) === null || _91 === void 0 ? void 0 : _91.id,
                            name: (_94 = (_93 = (_92 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _92 === void 0 ? void 0 : _92.contentMap) === null || _93 === void 0 ? void 0 : _93.version) === null || _94 === void 0 ? void 0 : _94.name,
                        },
                        class: {
                            id: (_97 = (_96 = (_95 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _95 === void 0 ? void 0 : _95.contentMap) === null || _96 === void 0 ? void 0 : _96.class) === null || _97 === void 0 ? void 0 : _97.id,
                            name: (_100 = (_99 = (_98 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _98 === void 0 ? void 0 : _98.contentMap) === null || _99 === void 0 ? void 0 : _99.class) === null || _100 === void 0 ? void 0 : _100.name,
                        },
                        type: {
                            id: (_103 = (_102 = (_101 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _101 === void 0 ? void 0 : _101.contentMap) === null || _102 === void 0 ? void 0 : _102.type) === null || _103 === void 0 ? void 0 : _103.id,
                            name: (_106 = (_105 = (_104 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _104 === void 0 ? void 0 : _104.contentMap) === null || _105 === void 0 ? void 0 : _105.type) === null || _106 === void 0 ? void 0 : _106.name,
                        },
                        weight: (_108 = (_107 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _107 === void 0 ? void 0 : _107.contentMap) === null || _108 === void 0 ? void 0 : _108.weight,
                        tonnage: (_110 = (_109 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _109 === void 0 ? void 0 : _109.contentMap) === null || _110 === void 0 ? void 0 : _110.tonnage,
                        passengerCant: (_112 = (_111 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _111 === void 0 ? void 0 : _111.contentMap) === null || _112 === void 0 ? void 0 : _112.passengerCant,
                    },
                ],
                year: (_114 = (_113 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _113 === void 0 ? void 0 : _113.contentMap) === null || _114 === void 0 ? void 0 : _114.year,
                carColor: [
                    {
                        id: (_117 = (_116 = (_115 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _115 === void 0 ? void 0 : _115.contentMap) === null || _116 === void 0 ? void 0 : _116.colors) === null || _117 === void 0 ? void 0 : _117.id,
                        name: (_120 = (_119 = (_118 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _118 === void 0 ? void 0 : _118.contentMap) === null || _119 === void 0 ? void 0 : _119.colors) === null || _120 === void 0 ? void 0 : _120.name,
                    },
                ],
                chassisNumber: (_122 = (_121 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _121 === void 0 ? void 0 : _121.contentMap) === null || _122 === void 0 ? void 0 : _122.chassisNumber,
                shortChassis: isChassisValid,
                price: (_124 = (_123 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _123 === void 0 ? void 0 : _123.contentMap) === null || _124 === void 0 ? void 0 : _124.deductibleTypeId,
                numberCylinders: [
                    {
                        id: (_126 = (_125 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _125 === void 0 ? void 0 : _125.contentMap) === null || _126 === void 0 ? void 0 : _126.cylinders,
                        name: (_128 = (_127 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _127 === void 0 ? void 0 : _127.contentMap) === null || _128 === void 0 ? void 0 : _128.cylinders,
                    },
                ],
                fuelType: [
                    {
                        id: (_130 = (_129 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _129 === void 0 ? void 0 : _129.contentMap) === null || _130 === void 0 ? void 0 : _130.combustion,
                        name: fuelTypeName,
                    },
                ],
                registrationNumber: (_132 = (_131 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _131 === void 0 ? void 0 : _131.contentMap) === null || _132 === void 0 ? void 0 : _132.plate,
                carCondition: [
                    {
                        id: (_134 = (_133 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _133 === void 0 ? void 0 : _133.contentMap) === null || _134 === void 0 ? void 0 : _134.condition,
                        name: carConditionName,
                    },
                ],
            });
            //EndFormVehicle
            //setStatementRows
            if (responseOneQuote.data.billing) {
                var dataRows = (_136 = (_135 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _135 === void 0 ? void 0 : _135.billing) === null || _136 === void 0 ? void 0 : _136.map(function (item) { return ({
                    accountName: item.account,
                    amount: "RD$ ".concat(item.amount),
                    paymentDate: newFormattedDate(item.paymentDate),
                    dateExpire: newFormattedDate(item.dateExpire),
                    datePaid: newFormattedDate(item.datePaid),
                    state: (function () {
                        switch (item.statusBilling) {
                            case "GENERATED":
                                return "Generado";
                            case "EMMITED":
                                return "Emitido";
                            case "PAID":
                                return "Pagado";
                            case "CANCELLED":
                                return "Cancelado";
                        }
                    })(),
                }); });
                setStatementRows(dataRows);
            }
            // EndSetStatmentRows
            // if (id) {
            // setPrime(responseOneQuote?.data?.lastPrice?.amount);
            setPrime(((_138 = (_137 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _137 === void 0 ? void 0 : _137.lastPrice) === null || _138 === void 0 ? void 0 : _138.amount)
                ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                : "0.00");
            callDispatchPageActionFlags((_140 = (_139 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _139 === void 0 ? void 0 : _139.planId) === null || _140 === void 0 ? void 0 : _140.projectId);
            // Update projectId from the quote response
            if ((_142 = (_141 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _141 === void 0 ? void 0 : _141.planId) === null || _142 === void 0 ? void 0 : _142.projectId) {
                console.log("Setting projectId from quote:", responseOneQuote.data.planId.projectId);
                setProjectId(responseOneQuote.data.planId.projectId);
            }
            if (id) {
                setLocalStorage(responseOneQuote.data, responseOneProject);
                // setSteps(stepProgress(STEP));
                // setBreadCrumbs(stepProgress(STEP, true));
                if (isQuote === "false") {
                    // setSteps(stepProgress(STEP_PAYMENTCONFIRMATION));
                    setBreadCrumbs([]);
                }
                else {
                    // setSteps(stepProgress(STEP));
                    setBreadCrumbs(stepProgress(STEP, true));
                }
                var certs = (_143 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _143 === void 0 ? void 0 : _143.certificates;
                //Get the certificates
                if (certs.length > 0) {
                    certs = certs.map(function (c, id) {
                        return {
                            id: c.id,
                            name: c.title,
                            url: c.url,
                        };
                    });
                }
                setCertificates(certs);
                //Get the additional payment info
                if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && isQuote && isQuote === "false") {
                    var additionalInfo = [];
                    var data = responseOneQuote.data;
                    var lastPrice = data.lastPrice, customerAccount = data.customerAccount, catalogPaymentMode_1 = data.catalogPaymentMode, id_1 = data.id;
                    var amount = (_144 = lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.amount) !== null && _144 !== void 0 ? _144 : "0.00";
                    var currencySymbol = (lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.currencySymbol) || "";
                    var formattedAmount = formatToTwoDecimals(amount);
                    additionalInfo.push({
                        id: id_1,
                        accountName: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountName,
                        accountNumber: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber,
                        accountType: (_145 = customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountType) === null || _145 === void 0 ? void 0 : _145.description,
                        paymentMode: catalogPaymentMode_1 === null || catalogPaymentMode_1 === void 0 ? void 0 : catalogPaymentMode_1.description,
                        prime: "".concat(currencySymbol, " ").concat(formattedAmount),
                        lastDigits: "N/A",
                    });
                    setRows2(additionalInfo);
                }
            }
            else {
                setRows2([
                    {
                        id: "1",
                        accountName: "N/A",
                        accountNumber: "N/A",
                        accountType: "N/A",
                        paymentMode: "N/A",
                        prime: "N/A",
                        lastDigits: "N/A",
                    },
                ]);
            }
            /*Adiciona al resumen la informacion de vehiculos*/
            switch ((_147 = (_146 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _146 === void 0 ? void 0 : _146.contentMap) === null || _147 === void 0 ? void 0 : _147.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            var price = ((_149 = (_148 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _148 === void 0 ? void 0 : _148.lastPrice) === null || _149 === void 0 ? void 0 : _149.currencySymbol) &&
                ((_151 = (_150 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _150 === void 0 ? void 0 : _150.lastPrice) === null || _151 === void 0 ? void 0 : _151.amount)
                ? "".concat((_153 = (_152 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _152 === void 0 ? void 0 : _152.lastPrice) === null || _153 === void 0 ? void 0 : _153.currencySymbol, " ").concat((_155 = (_154 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _154 === void 0 ? void 0 : _154.lastPrice) === null || _155 === void 0 ? void 0 : _155.amount)
                : "RD$ 0.00";
            var baseFilters = [
                {
                    name: "Producto",
                    type: "label",
                    label: (_158 = (_157 = (_156 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _156 === void 0 ? void 0 : _156.productId) === null || _157 === void 0 ? void 0 : _157.description) !== null && _158 !== void 0 ? _158 : "",
                },
                {
                    name: "Plan",
                    type: "label",
                    label: (_161 = (_160 = (_159 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _159 === void 0 ? void 0 : _159.planId) === null || _160 === void 0 ? void 0 : _160.name) !== null && _161 !== void 0 ? _161 : "",
                    showChangeButton: isQuoteType,
                },
                {
                    name: "Modalidad de Pago",
                    type: "label",
                    label: (_164 = (_163 = (_162 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _162 === void 0 ? void 0 : _162.catalogPaymentMode) === null || _163 === void 0 ? void 0 : _163.description) !== null && _164 !== void 0 ? _164 : "",
                },
                {
                    name: "Tipo de Cobertura",
                    type: "label",
                    label: (_167 = (_166 = (_165 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _165 === void 0 ? void 0 : _165.catalogPaymentMode) === null || _166 === void 0 ? void 0 : _166.description) !== null && _167 !== void 0 ? _167 : "",
                },
                {
                    name: "Campaña",
                    type: "label",
                    label: (_170 = (_169 = (_168 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _168 === void 0 ? void 0 : _168.campaignId) === null || _169 === void 0 ? void 0 : _169.name) !== null && _170 !== void 0 ? _170 : "",
                },
            ];
            var filtersPlan = [
                {
                    name: "Prima",
                    type: "label",
                    label: price,
                },
            ];
            setDefaultFilters(isQuote === "false" ? __spreadArray(__spreadArray([], baseFilters, true), filtersPlan, true) : baseFilters);
        }
        dispatch(projectOneClearData());
    }, [responseOneQuote]);
    // Separate useEffect to handle plan API call after quote data is processed
    // Only call plan API when both catalogPaymentMode.id and projectId are available
    useEffect(function () {
        var _a, _b;
        if (((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id) && projectId) {
            callDispatchPlan(null, null);
        }
    }, [(_p = (_o = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _o === void 0 ? void 0 : _o.catalogPaymentMode) === null || _p === void 0 ? void 0 : _p.id, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(function () {
        var _a, _b, _c;
        if (responseOneProject) {
            setSalesFlow(responseOneProject.salesFlow);
            setProductType((_c = (_b = (_a = responseOneProject.salesFlow) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.navigation) === null || _c === void 0 ? void 0 : _c.productType);
            if (idProject) {
                // localStorageService.setStepStored({
                //   id: "",
                //   name: "",
                //   step: Steps.insurance,
                //   completed: true,
                //   flow: responseOneProject.salesFlow,
                // });
            }
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogBeneficiary && (responseGetCatalogBeneficiary === null || responseGetCatalogBeneficiary === void 0 ? void 0 : responseGetCatalogBeneficiary.data)) {
            var beneficiaryList_1 = [];
            (_a = responseGetCatalogBeneficiary.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                beneficiaryList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setBeneficiaryType(beneficiaryList_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { idTypeInsured: (_b = beneficiaryList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogBeneficiary]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogInsurance && (responseGetCatalogInsurance === null || responseGetCatalogInsurance === void 0 ? void 0 : responseGetCatalogInsurance.data)) {
            var insuranceList_1 = [];
            (_a = responseGetCatalogInsurance.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                insuranceList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                    code: (_a = item.code) !== null && _a !== void 0 ? _a : "",
                });
            });
            setInsuredType(insuranceList_1);
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { idTypeInsured: (_b = insuranceList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogInsurance]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePlans) {
            var dataST_1 = [];
            // Prioritize payment mode from quote data
            var paymentModeFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
            var pm = (_c = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _c === void 0 ? void 0 : _c.name;
            // Use quote data first, then period state, then localStorage
            var paymentPeriod_1 = paymentModeFromQuote || period || pm;
            if (period === undefined && paymentPeriod_1) {
                setPeriod(paymentPeriod_1);
            }
            responsePlans.map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : []),
                    period: paymentPeriod_1,
                    price: item.price ? (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount : "0",
                    textColor: "#3A56A1",
                });
            });
            setPlanData(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [responsePlans, responseOneQuote]);
    /*
    useEffect(() => {
      if (permissionList?.length > 0) {
        setTriggerPermissionList(false);
      }
    }, [permissionList]);
  */
    useEffect(function () {
        if (listIdentificationType.length > 0 &&
            listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0 &&
            !showComponent) {
            setShowComponent(true);
        }
    }, [
        listIdentificationType,
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    useEffect(function () {
        if (responsePageActionFlags) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            setActionFlags(responsePageActionFlags);
            getActionFlags();
            dispatch(pageActionFlagsClearData());
            responsePageActionFlags === null || responsePageActionFlags === void 0 ? void 0 : responsePageActionFlags.forEach(function (actionFlag) {
                if (actionFlag.name === "afy-show-plan-travel-range-info") {
                    console.log("Travel Insurance Flag Found", premiumSum);
                    setIsTravelInsurance(true);
                }
            });
        }
    }, [responsePageActionFlags]);
    useEffect(function () {
        if (responsePatchBeneficiary && responsePatchBeneficiary.data) {
            showToastSuccessMessage("Beneficiario actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            dispatch(patchBeneficiaryClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchBeneficiary]);
    useEffect(function () {
        if (responsePatchInsured && responsePatchInsured.data) {
            showToastSuccessMessage("Asegurado actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            // dispatch(person({ enable: true, page: 1, limit: 1000 }));
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchInsured]);
    useEffect(function () {
        if (responsePostInsured) {
            showToastSuccessMessage("Asegurado agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            getInsuredBeneficiary();
        }
    }, [responsePostInsured]);
    useEffect(function () {
        if (responseUpdatePerson === null || responseUpdatePerson === void 0 ? void 0 : responseUpdatePerson.data) {
            showToastSuccessMessage("Agregado con éxito.", typeAlert.success, setSeeToast);
            // if (id !== undefined) {
            dispatch(quoteClearData());
            dispatch(quoteOne({ id: id !== null && id !== void 0 ? id : quoteId, fullBody: true }));
            // } else {
            //   dispatch(
            //     quoteOne({
            //       id: quoteId ?? id,
            //       fullBody: true,
            //     }),
            //   );
            // }
        }
    }, [responseUpdatePerson]);
    useEffect(function () {
        if (responseBenefit && (responseBenefit === null || responseBenefit === void 0 ? void 0 : responseBenefit.data)) {
            showToastSuccessMessage("Beneficiario agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModalBeneficiary(false);
            getInsuredBeneficiary();
            dispatch(benefitClearData());
        }
    }, [responseBenefit]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            // Payment mode selection is now handled by responsePaymentMode useEffect
            // This ensures paymentModelSelected is set from the dedicated PaymentModes API
        }
    }, [responsePlan]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf_1 = [];
            (_b = responseIdentificationType.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                idf_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setListIdentificationType(idf_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { IdType: (_c = idf_1[0].value) !== null && _c !== void 0 ? _c : "" }));
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { IdType: (_d = idf_1[0].value) !== null && _d !== void 0 ? _d : "" }));
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a, _b;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCatalogGender.data) === null || _b === void 0 ? void 0 : _b.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        var _a, _b;
        if (responseCountries && ((_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCountries.data) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCountries]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        if (responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) {
            setBeneficiaryStorybook(responseBeneficiary.data);
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        if (responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) {
            setInsuranceStorybook(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data);
            setSessionData(responseInsured);
        }
    }, [responseInsured]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            /* Payment modes are now loaded from dedicated API - see useEffect for responsePaymentMode */
            /* Filtrar por coverage type */
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            if (result.length > 0) {
                setCoverageType(result);
            }
            /* Filtrar por insured type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_INSURED_TYPE);
            // if (result.length > 0) {
            //   setInsuredType(result);
            //   setDataFormInsurance({
            //     ...dataFormInsurance,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
            /* Filtrar por beneficiary type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            // if (result.length > 0) {
            //   setBeneficiaryType(result);
            //   setDataFormBeneficiary({
            //     ...dataFormBeneficiary,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
        }
    }, [responsePlan]);
    useEffect(function () {
        if (actionFlags.length > 0) {
            getActionFlags();
        }
    }, [actionFlags]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.length)) {
            setFilters(defaultFilters);
            return;
        }
        var byLabel = Object.fromEntries(summary.data.map(function (i) { return [i.label, i.value]; }));
        // Orden grupo deseado
        var header = ["Documento", "No. de cotización"];
        var cliente = ["Nombres", "Apellidos"];
        var used = new Set(__spreadArray(__spreadArray([], header, true), cliente, true));
        var producto = summary.data.filter(function (i) { return !used.has(i.label); });
        var out = __spreadArray([
            {
                name: "Número de cotización",
                label: (_b = byLabel["No. de cotización"]) !== null && _b !== void 0 ? _b : "-",
                type: "label",
            },
            {
                name: "Número de documento",
                label: (_c = byLabel["Documento"]) !== null && _c !== void 0 ? _c : "-",
                type: "label",
            },
            // Subtítulo cliente
            {
                name: "Datos del cliente",
                label: "Datos del cliente",
                type: "subtitle",
            },
            { name: "Nombres", label: (_d = byLabel["Nombres"]) !== null && _d !== void 0 ? _d : "-", type: "label" },
            { name: "Apellidos", label: (_e = byLabel["Apellidos"]) !== null && _e !== void 0 ? _e : "-", type: "label" },
            // Subtítulo producto
            {
                name: "Datos del producto",
                label: "Datos del producto",
                type: "subtitle",
            }
        ], producto.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); }), true);
        setFilters(out);
    }, [summary, defaultFilters]);
    useEffect(function () {
        if (responsePersonByDocument && responsePersonByDocument.length > 0) {
            var dataPerson = responsePersonByDocument[0];
            var updatedDataFormPerson = updateDataFormPerson(dataPerson, isInsurance ? dataFormInsurance : dataFormBeneficiary);
            if (isInsurance) {
                setDataFormInsurance(updatedDataFormPerson);
            }
            else {
                setDataFormBeneficiary(updatedDataFormPerson);
            }
            setTrigger(false);
            dispatch(personByDocumentClearData());
        }
        if ((responsePersonByDocument === null || responsePersonByDocument === void 0 ? void 0 : responsePersonByDocument.length) === 0) {
            if (isInsurance) {
                setDataFormInsurance({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            else {
                setDataFormBeneficiary({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            dispatch(personByDocumentClearData());
        }
    }, [responsePersonByDocument, isInsurance, trigger]);
    useEffect(function () {
        setUploadTrigger(false);
        setOpenDrawerUpload(false);
        dispatch(postQuoteUploadDocumentClearData());
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteId);
        }
    }, [responseUploadDocuments]);
    var columnsInsurance = Tab1Columns(editInsured, canEditInsured);
    var columnsBeneficiary = Tab2Columns(editBeneficiary, canEditBeneficiary);
    var callGetInsuredBeneficiary = function (quoteId) {
        var id_ = quoteId;
        if (id_) {
            if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) && !(responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data)) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
            }
        }
    };
    // Passenger Download Modal State
    var _129 = useState(false), openPassengerModal = _129[0], setOpenPassengerModal = _129[1];
    var _130 = useState(false), openModalAddPassenger = _130[0], setOpenModalAddPassenger = _130[1];
    var _131 = useState(""), selectedQuoteId = _131[0], setSelectedQuoteId = _131[1];
    var _132 = useState(null), editingPassengerId = _132[0], setEditingPassengerId = _132[1];
    var _133 = useState(null), editingPassengerData = _133[0], setEditingPassengerData = _133[1];
    var handleAddPassanger = function () {
        setEditingPassengerId(null);
        setEditingPassengerData(null);
        setOpenModalAddPassenger(true);
    };
    var onClickPassangerDownload = React.useCallback(function () {
        setSelectedQuoteId(quoteId);
        setOpenPassengerModal(true);
    }, [quoteId]);
    var handlePassengerModalClose = React.useCallback(function () {
        setOpenPassengerModal(false);
        setSelectedQuoteId("");
    }, []);
    var handleOpenPdf = React.useCallback(function (url, name) {
        setUrlDocumentPassenger(url);
        setNameDocumentPassenger(name);
        setOpenModalPassenger(true);
    }, []);
    var handleEditPassenger = React.useCallback(function (row) {
        var _a, _b;
        console.log("Editing passenger:", row);
        setEditingPassengerId(row.row.id);
        // Find the original IDs from the names
        var idTypeId = ((_a = listIdentificationType.find(function (item) { return item.name === row.row.idType; })) === null || _a === void 0 ? void 0 : _a.id) || "";
        var genderId = ((_b = listGenders.find(function (item) { return item.name === row.row.gender; })) === null || _b === void 0 ? void 0 : _b.id) || "";
        setEditingPassengerData({
            Name: row.row.name,
            LastName: row.row.lastName,
            IdType: idTypeId,
            DocumentNumber: row.row.documentNumber,
            Birthday: row.row.birthDate,
            Gender: genderId,
            Email: row.row.email,
            PhoneNumber: row.row.phone,
        });
        setOpenModalAddPassenger(true);
    }, [listIdentificationType, listGenders]);
    var handleDeletePassenger = React.useCallback(function (row) {
        console.log("Deleting passenger:", row);
        setRowsPassengers(function (prev) { return prev.filter(function (p) { return p.id !== row.row.id; }); });
    }, []);
    var handleSavePassenger = React.useCallback(function (data) {
        var _a, _b, _c, _d, _e, _f, _g;
        console.log("Data from passenger to save:", data);
        // Use data from responsePersonByDocument if available, otherwise use form data
        var personData = responsePersonByDocument && responsePersonByDocument.length > 0
            ? responsePersonByDocument[0]
            : null;
        console.log("Person data from responsePersonByDocument:", personData);
        // Find identification type name
        var idTypeObj = listIdentificationType.find(function (item) { var _a; return item.id === (((_a = personData === null || personData === void 0 ? void 0 : personData.identificationTypeId) === null || _a === void 0 ? void 0 : _a.id) || data.IdType); });
        var genderObj = listGenders.find(function (item) { var _a; return item.id === (((_a = personData === null || personData === void 0 ? void 0 : personData.catalogGender) === null || _a === void 0 ? void 0 : _a.id) || data.Gender); });
        var rawBirthDate = (personData === null || personData === void 0 ? void 0 : personData.dob) || data.Birthday || "";
        var formattedBirthDate = rawBirthDate
            ? newFormattedDate(rawBirthDate)
            : "";
        var age = rawBirthDate ? calculateAge(rawBirthDate) : 0;
        // Create or update passenger row
        var passengerRow = {
            id: editingPassengerId || rowsPassengers.length + 1,
            name: (personData === null || personData === void 0 ? void 0 : personData.firstNameA) || data.Name || "",
            lastName: (personData === null || personData === void 0 ? void 0 : personData.lastNameA) || data.LastName || "",
            idType: (idTypeObj === null || idTypeObj === void 0 ? void 0 : idTypeObj.name) || "",
            documentNumber: (personData === null || personData === void 0 ? void 0 : personData.numberId) || data.DocumentNumber || "",
            birthDate: formattedBirthDate,
            age: age,
            gender: (genderObj === null || genderObj === void 0 ? void 0 : genderObj.name) || "",
            passport: data.Passport || "",
            email: (personData === null || personData === void 0 ? void 0 : personData.email) || data.Email || "",
            phone: (personData === null || personData === void 0 ? void 0 : personData.phone1) || (personData === null || personData === void 0 ? void 0 : personData.phone3) || data.PhoneNumber || "",
        };
        if (editingPassengerId) {
            // Update existing passenger
            setRowsPassengers(function (prev) {
                return prev.map(function (p) { return (p.id === editingPassengerId ? passengerRow : p); });
            });
            console.log("Passenger updated in table:", passengerRow);
            setEditingPassengerId(null);
            setEditingPassengerData(null);
        }
        else {
            // Add new passenger
            setRowsPassengers(function (prev) { return __spreadArray(__spreadArray([], prev, true), [passengerRow], false); });
            console.log("Passenger added to table:", passengerRow);
        }
        // Only add insured if there are no existing insured records
        if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) || responseInsured.data.length === 0) {
            console.log("No insured records found, creating insured from passenger data");
            // Map passenger data to insured body structure
            var body = {
                quoteId: quoteId || id,
                catalogInsuredType: ((_a = insuredType[0]) === null || _a === void 0 ? void 0 : _a.value) || "f97da54f-2ee9-4bca-8063-596b74057e34",
                person: {
                    firstNameA: (personData === null || personData === void 0 ? void 0 : personData.firstNameA) || data.Name || "",
                    firstNameB: (personData === null || personData === void 0 ? void 0 : personData.firstNameB) || data.SecondName || "",
                    lastNameA: (personData === null || personData === void 0 ? void 0 : personData.lastNameA) ||
                        data.LastName ||
                        data.FirstLastName ||
                        "",
                    lastNameB: (personData === null || personData === void 0 ? void 0 : personData.lastNameB) || data.SecondLastName || "",
                    identificationTypeId: ((_b = personData === null || personData === void 0 ? void 0 : personData.identificationTypeId) === null || _b === void 0 ? void 0 : _b.id) || data.IdType || "",
                    numberId: ((personData === null || personData === void 0 ? void 0 : personData.numberId) ||
                        data.DocumentNumber ||
                        "").replace(/-/g, ""),
                    dob: (personData === null || personData === void 0 ? void 0 : personData.dob) || data.Birthday || "",
                    catalogGender: ((_c = personData === null || personData === void 0 ? void 0 : personData.catalogGender) === null || _c === void 0 ? void 0 : _c.id) || data.Gender || "",
                    marriedName: (personData === null || personData === void 0 ? void 0 : personData.marriedName) || data.MarriedSurName || "",
                    nationality: ((_d = personData === null || personData === void 0 ? void 0 : personData.nationality) === null || _d === void 0 ? void 0 : _d.id) || data.Country || clientId,
                    province: ((_e = personData === null || personData === void 0 ? void 0 : personData.province) === null || _e === void 0 ? void 0 : _e.id) || data.Province || "",
                    municipality: ((_f = personData === null || personData === void 0 ? void 0 : personData.municipality) === null || _f === void 0 ? void 0 : _f.id) || data.Town || "",
                    district: ((_g = personData === null || personData === void 0 ? void 0 : personData.district) === null || _g === void 0 ? void 0 : _g.id) || data.Sector || "",
                    zip: (personData === null || personData === void 0 ? void 0 : personData.zip) || data.PostalCode || "",
                    address1: (personData === null || personData === void 0 ? void 0 : personData.address1) || data.Address1 || "",
                    phone1: removeNonNumeric((personData === null || personData === void 0 ? void 0 : personData.phone1) || data.PhoneHome || data.PhoneNumber || null),
                    phone3: removeNonNumeric((personData === null || personData === void 0 ? void 0 : personData.phone3) || data.PhoneNumber || null),
                    phone2: removeNonNumeric((personData === null || personData === void 0 ? void 0 : personData.phone2) || data.PhoneOffice || null),
                    email: (personData === null || personData === void 0 ? void 0 : personData.email) || data.Email || "",
                    clientId: clientId,
                },
            };
            console.log("Creating insured with body:", body);
            //dispatch(postInsured(body));
        }
        else {
            console.log("Insured records exist, skipping insured creation");
        }
        setOpenModalAddPassenger(false);
    }, [
        quoteId,
        id,
        responseInsured,
        responsePersonByDocument,
        insuredType,
        clientId,
        dispatch,
        rowsPassengers,
        listIdentificationType,
        listGenders,
    ]);
    // Calculate passenger age from birth date
    var calculateAge = function (birthDate) {
        if (!birthDate)
            return 0;
        var today = new Date();
        var birth = new Date(birthDate);
        var age = today.getFullYear() - birth.getFullYear();
        var monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    };
    // Validate passengers match age ranges
    var validatePassengerAges = function () {
        if (!isTravelInsurance || rowsPassengers.length === 0)
            return true;
        var ageRanges = {
            edad020: 0,
            edad2174: 0,
            edad7585: 0,
        };
        // Count passengers in each age range
        rowsPassengers.forEach(function (passenger) {
            var age = calculateAge(passenger.birthDate);
            if (age >= 0 && age <= 20) {
                ageRanges.edad020++;
            }
            else if (age >= 21 && age <= 74) {
                ageRanges.edad2174++;
            }
            else if (age >= 75 && age <= 85) {
                ageRanges.edad7585++;
            }
        });
        console.log("Age range counts:", ageRanges);
        console.log("Expected counts - edad020:", edad020, "edad2174:", edad2174, "edad7585:", edad7585);
        // Check if age ranges match the exact expected counts
        var edad020Match = ageRanges.edad020 === edad020;
        var edad2174Match = ageRanges.edad2174 === edad2174;
        var edad7585Match = ageRanges.edad7585 === edad7585;
        console.log("Validation results - edad020Match:", edad020Match, "edad2174Match:", edad2174Match, "edad7585Match:", edad7585Match);
        return edad020Match && edad2174Match && edad7585Match;
    };
    // Calculate total expected passengers from premium sum
    var getTotalExpectedPassengers = function () {
        var total = 0;
        if (edad020 > 0)
            total++;
        if (edad2174 > 0)
            total++;
        if (edad7585 > 0)
            total++;
        return total;
    };
    // Check if passenger validation passes
    var isPassengerValidationPassed = isTravelInsurance
        ? rowsPassengers.length === premiumSum && validatePassengerAges()
        : true;
    // Generate passenger requirement message
    var getPassengerRequirementMessage = function () {
        if (!isTravelInsurance)
            return "";
        var currentCounts = {
            edad020: 0,
            edad2174: 0,
            edad7585: 0,
        };
        rowsPassengers.forEach(function (passenger) {
            var age = calculateAge(passenger.birthDate);
            if (age >= 0 && age <= 20) {
                currentCounts.edad020++;
            }
            else if (age >= 21 && age <= 74) {
                currentCounts.edad2174++;
            }
            else if (age >= 75 && age <= 85) {
                currentCounts.edad7585++;
            }
        });
        var isAllOk = isPassengerValidationPassed;
        var currentCount = rowsPassengers.length;
        var requiredCount = premiumSum;
        if (isAllOk) {
            var requirements = [];
            if (edad020 > 0)
                requirements.push("".concat(edad020, " pasajero").concat(edad020 > 1 ? "s" : "", " (0-20 a\u00F1os)"));
            if (edad2174 > 0)
                requirements.push("".concat(edad2174, " pasajero").concat(edad2174 > 1 ? "s" : "", " (21-74 a\u00F1os)"));
            if (edad7585 > 0)
                requirements.push("".concat(edad7585, " pasajero").concat(edad7585 > 1 ? "s" : "", " (75-85 a\u00F1os)"));
            var text = "Se requiere".concat(requirements.length > 0
                ? ": " + requirements.join(", ")
                : "s " + requiredCount + " pasajero" + (requiredCount > 1 ? "s" : ""), ". Agregados: ").concat(currentCount, "/").concat(requiredCount);
            return _jsx("span", __assign({ style: { color: "green" } }, { children: text }));
        }
        var requirementsNodes = [];
        var missing020 = Math.max(0, edad020 - currentCounts.edad020);
        if (missing020 > 0) {
            requirementsNodes.push(_jsx("span", __assign({ style: { color: themeCore.colors.error, fontWeight: "bold" } }, { children: "".concat(missing020, " pasajero").concat(missing020 > 1 ? "s" : "", " (0-20 a\u00F1os)") }), "0-20"));
        }
        var missing2174 = Math.max(0, edad2174 - currentCounts.edad2174);
        if (missing2174 > 0) {
            requirementsNodes.push(_jsx("span", __assign({ style: { color: themeCore.colors.error, fontWeight: "bold" } }, { children: "".concat(missing2174, " pasajero").concat(missing2174 > 1 ? "s" : "", " (21-74 a\u00F1os)") }), "21-74"));
        }
        var missing7585 = Math.max(0, edad7585 - currentCounts.edad7585);
        if (missing7585 > 0) {
            requirementsNodes.push(_jsx("span", __assign({ style: { color: themeCore.colors.error, fontWeight: "bold" } }, { children: "".concat(missing7585, " pasajero").concat(missing7585 > 1 ? "s" : "", " (75-85 a\u00F1os)") }), "75-85"));
        }
        return (_jsxs("span", { children: [requirementsNodes.length > 0 ? "Faltan" : "Se requiere", requirementsNodes.length > 0 ? (_jsxs(_Fragment, { children: [":", " ", requirementsNodes.reduce(function (prev, curr) { return [
                            prev,
                            ", ",
                            curr,
                        ]; })] })) : (_jsx("span", __assign({ style: { color: themeCore.colors.error, fontWeight: "bold" } }, { children: ": ".concat(requiredCount, " pasajero").concat(requiredCount > 1 ? "s" : "") }))), ". Agregados: ", currentCount, "/", requiredCount] }));
    };
    var columnsPassenger = React.useMemo(function () { return __spreadArray([
        {
            field: "actions",
            headerName: "Acciones",
            width: 150,
            renderCell: function (params) { return (_jsx(_Fragment, { children: _jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Eliminar", color: themeCore.colors.error, onClick: function () { return handleDeletePassenger(params); } }) })); },
        }
    ], Tab4Columns, true); }, [handleEditPassenger, handleDeletePassenger]);
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: titleInsured, hideStep: isQuote === "false", steps: steps, completed: isQuote === "false" }), _jsx(ConfirmationHeader, { loading: loadingPostInsured ||
                    loadingUpdatePerson ||
                    loadingOneQuote ||
                    loadingBenefit ||
                    loadingPostInsured ||
                    loadingPatchBeneficiary ||
                    loadingPatchInsured ||
                    loadingPersonByDocument ||
                    loadingOneProject ||
                    loadingBeneficiary ||
                    loading ||
                    loadingPlans ||
                    loadingUpdateQuote ||
                    loadingUploadDocuments ||
                    loadingGetCatalogBeneficiary ||
                    loadingGetCatalogInsurance ||
                    loadingCertificateQuote ||
                    loadingInsured ||
                    loadingPaymentMode ||
                    loadingComplete ||
                    loadingCalculate, text: loadingUpdatePerson || loadingUpdateQuote
                    ? "Actualizando datos."
                    : loadingUploadDocuments
                        ? "Subiendo documento..."
                        : "Cargando...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), openPassengerModal && (_jsx(PassengerDownloadModal, { open: openPassengerModal, onClose: handlePassengerModalClose, setSeeToast: setSeeToast, quoteId: selectedQuoteId, onOpenPdf: handleOpenPdf })), showComponent ? (_jsx(Suspense, { children: _jsx(ConfirmationFormView, { onClickPassangerDownload: onClickPassangerDownload, isTravelInsurance: isTravelInsurance, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, breadcrumbs: breadCrumbs, steps: steps, 
                    /* PDF VIEWER DOCUMENT*/
                    openModal: openModalPdfViewer, setOpenModal: setopenModalPdfViewer, documentName: nameDocument, urlDocument: urlDocument, 
                    /* PDF VIEWER CLIENT*/
                    openModalClient: modalDocumentClient, setOpenModalClient: setModalDocumentClient, documentNameClient: docName, urlDocumentClient: urlDocumentClient, 
                    /* PDF VIEWER PASSENGER */
                    openModalPassenger: openModalPassenger, setOpenModalPassenger: setOpenModalPassenger, documentNamePassenger: nameDocumentPassenger, urlDocumentPassenger: urlDocumentPassenger, 
                    /* MODAL EDIT VEHICLE */
                    openModalEditVehicle: openModalEditVehicle, setOpenModalEditVehicle: setOpenModalEditVehicle, dataFormVehicle: dataFormVehicle, callQuoteOneApi: callQuoteOne, quoteId: id ? id : quoteId, planId: planId, coverTypeId: coverTypeId, campaignId: campaignId, catalogPaymentMode: catalogPaymentMode, catalogStatusQuote: catalogStatusQuote, branchId: branchId, userId: userId, idQuoteVehicle: idQuoteVehicle, productId: productId, t: t, planName: planName, productType: productType, projectTypeLocal: projectTypeLocal, salesFlow: salesFlow, 
                    /* MODAL BENEFICIARY */
                    openModalBeneficiary: openModalBeneficiary, setOpenModalBeneficiary: setOpenModalBeneficiary, isMaskedDocument: isMaskedDocument, dataFormBeneficiary: dataFormBeneficiary, titleBeneficiary: titleBeneficiary, beneficiaryType: beneficiaryType, listIdentificationType: listIdentificationType, initialPercentage: initialPercentage, handleSubmitBeneficiary: function () {
                        return handleSubmitBeneficiary(dataFormBeneficiary);
                    }, searchPerson: function (e) {
                        return searchPerson(e, setIsInsurance, setDocument, setTrigger);
                    }, 
                    /* MODAL INSURED */
                    openModalInsured: openModal, setOpenModalInsured: setOpenModal, dataFormInsurance: dataFormInsurance, titleInsured: titleInsured, insuredType: insuredType, handleSubmitInsured: function (data) { return handleSubmitInsured(data); }, searchInsurancePerson: function (e) { return searchInsurancePerson(e); }, 
                    /* MODAL CONFIRMATION */
                    openModalBackConfirm: openModalBackConfirm, handleCloseBackModal: handleCloseBackModal, handleBackFromModal: handleBackFromModal, classes: classes, 
                    /* VIEW */
                    isRequired: !isApap, tabAdditionalDocumentation: "Documentos Clientes", countBadgeContent: countBadge, customBadgeColor: "#fba730", badgeColorText: "#ffffff", additionalDocumentationColumns: AdditionalDocumentationColumns(handleClickContextMenu), additionalDocumentationRows: profileDocumentsRows, hideMarriedName: hideMarriedName, titleDrawer: "Suba el documento solicitado.", descriptionDrawer: "Arrastra el documento solicitado a la zona de color o haz clic en el área de color para seleccionarlo. Solo puedes subir un documento a la vez, y solo se permiten archivos en formato PDF.", titleUpload: "Arrastre y suelte su archivo.", heightDrawer: "100%", disableSelectCountry: true, openDrawerUpload: openDrawerUpload, onCloseDrawer: function () {
                        setOpenDrawerUpload(false);
                    }, onUpload: quoteUploadDocuments, tabAuto: "Auto Asegurado", tabAutoDescription: "", tabStatement: "Estado de cuenta", tabStatementColumns: StatementColumns(t), tabStatementRows: statementRows, TabAutoColumns: TabAutoColumns(updateVehicle, isQuote ? isQuote : ""), TabAutoRows: listVehiclesDetail, onChangeSelect: handleChangeSelect, handleChangeSelectFormInsurance: handleChangeSelectFormInsurance, 
                    // ***--- PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    onClickAutoDownload: handleOnClickAutoDownload, btnLblDownload: "Descargar Cotización", showButtonDownloadApap: !showVehicleData || !showDownloadQuote, onClickAutoDownloadVida: handleOnClickAutoDownloadVida, btnLblDownloadVida: "Descargar Solicitud", showButtonDownloadVida: !showDownloadRequest, 
                    // ***--- END PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    labelNumberQuote: ((_q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _q === void 0 ? void 0 : _q.policyId)
                        ? "No. de póliza"
                        : "No. de cotización", title: "Confirmación de datos", identificationList: listIdentificationType, GenderList: listGenders, CountryList: listCountries, ProvinceList: listRegionLevel1, TownList: listRegionLevel2, SectorList: listRegionLevel3, dataForm: dataForm, hideTabs: [
                        showInsured,
                        showBeneficiary,
                        !(isQuote === "false"),
                        showVehicleData,
                        true,
                        hideTabDocumentClient,
                        !isTravelInsurance,
                        showTabRealEstates,
                    ], hideAddButton: [addInsured, addBeneficiary], showAdd: true, showActions: canEdit, showContactActions: canEditContact, showLocationActions: canEditLocation, showDownloads: !canEdit, onClickDownload: handleDownload, certificates: certificates, dateLabel: isQuote !== null && isQuote === "false"
                        ? "Fecha efectiva"
                        : "Fecha de cotización", downloadsTitle: "Descargas", labelAdd: "Agregar", tab1: "Personas aseguradas", tab1Description: "Asegurados", tab2: "Beneficiarios", tab2Description: "Beneficiarios", tab3: "Información de pago", tab3Description: "", Tab1Columns: columnsInsurance, Tab1Rows: rows, Tab2Columns: columnsBeneficiary, Tab2Rows: rowsBeneficiary, Tab3Columns: Tab3Columns, Tab3Rows: rows2, 
                    //Travel Insurance Tab4
                    tab4: "Pasajeros", 
                    /////
                    Tab4Columns: columnsPassenger, Tab4Rows: rowsPassengers, hide2: true, options1: paymentMode, options2: [], options3: campaignInfo, firstSubtitle: "Información de cotización", secondSubtitle: "Información general del cliente", thirdSubtitle: "Información de ubicación", fourthSubtitle: "Información de contacto", plan: plan, plans: planData.data || [], paymentMethodData: paymentMode, campaignData: campaign, showPaymentMethod: true, showCampaign: true, onClickAdd: handleAddInsured, onClickRowGrid: function () { }, onClickAddBeneficiary: handleAddBeneficiary, filters: filters, titleSelectButton: "Adquirir", previousLabel: "Anterior", nextLabel: !isVidaTermino ? "Siguiente" : "Finalizar", showPrevious: canEdit, nextDisabled: !permissions.create ||
                        !canEdit ||
                        isNextDisabled ||
                        !isPassengerValidationPassed, onBack: onClickBack, onClickSave: handleUpdatePerson, onNext: handleNext, onClickPrevious: handlePrevious, onBlurInput: function () { }, onChangeInput: function () { }, onClickCancel: function () { }, disableDocumentType: true, disableDocumentNumber: true, onChangePaymentMethod: handleOnChangePaymentMethod, onChangeCampaign: handleOnChangeCampaign, onChangeCoverType: handleOnChangeCoverType, onClickAcquire: handleOnClickAcquire, disabledDownloadVida: false, isQuote: isQuote, isPlan: isPlan, openModalAddInsurance: openModalAddInsurance, setOpenModalAddInsurance: setOpenModalAddInsurance, dataFormInsuranceSp: dataFormInsuranceSp, showButtonActivatePolicy: showButtonActivatePolicy, openActivePolicy: openActivePolicy, setOpenActivePolicy: setOpenActivePolicy, policyId: policyId, callQuoteOne: callQuoteOne, onClickAddPassanger: handleAddPassanger, openModalAddPassenger: openModalAddPassenger, setOpenModalAddPassenger: setOpenModalAddPassenger, editingPassengerData: editingPassengerData, handleSavePassenger: handleSavePassenger, 
                    //home/business
                    setOpenModalAddBusiness: setOpenModalAddBusiness, openModalAddBusiness: openModalAddBusiness, isCommerce: isCommerce, tab4Description: getPassengerRequirementMessage(), TabRealEstateRows: [], dataFormBusiness: dataFormBusiness, damageBackup: damageBackup, insuredProperty: insuredProperty, showFormBusiness: showFormBusiness, openModalAddHome: openModalAddHome, setOpenModalAddHome: setOpenModalAddHome, onSameDirection: onSameDirection, productCode: productCode, planCode: planCode, onCalculateRate: onCalculateRate, setDataFormBusiness: setDataFormBusiness }) })) : (_jsx("div", {}))] }));
};
export default ConfirmationForm;
